// extracted by mini-css-extract-plugin
module.exports = {"toggle_2_15r6":"toggle_2_15r6","anypoint-icon":"anypoint-icon","js-focus-visible":"js-focus-visible","focus-visible":"focus-visible"};